import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-8b6855b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "sidebar-container" }
const _hoisted_2 = {
  key: 0,
  style: {"font-weight":"bolder","font-size":"30px","color":"blue","text-align":"center","width":"100%"}
}
const _hoisted_3 = { class: "logo mx-auto" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "img-logo",
  alt: "TAWA Digital Talents"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "img-logo",
  alt: "TAWA Digital Talents"
}, null, -1))
const _hoisted_6 = { class: "item nav-links flex-column" }
const _hoisted_7 = { style: {"width":"145px"} }
const _hoisted_8 = {
  key: 0,
  class: "sidbar-count-bubble"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["side-navbar d-flex flex-wrap flex-row align-items-center", {
        'active-nav': _ctx.activeSidebar,
        'sidenav-border-staging': _ctx.node_env != 'prod',
      }]),
      id: "sidebar"
    }, [
      (_ctx.node_env != 'prod')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.node_env), 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSideNav && _ctx.toggleSideNav(...args))),
        class: "sidenav-toggle"
      }, [
        _createVNode(_component_inline_svg, {
          src: require('@/assets/images/icons/toggle-menu.svg')
        }, null, 8, ["src"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isAdvertiser === true)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: "/discover",
              class: "logo mx-auto"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: "/profile",
              class: "logo mx-auto"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }))
      ]),
      _createElementVNode("ul", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sideLinks, (sideLink, idx) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (sideLink?.rules?.roles?.includes(_ctx.token_service.getRole()))
              ? (_openBlock(), _createElementBlock("li", {
                  key: idx,
                  class: "nav-item w-95"
                }, [
                  _createVNode(_component_router_link, {
                    to: sideLink.href,
                    onClick: ($event: any) => (_ctx.menuLinkClicked(sideLink.href)),
                    "exact-active-class": "active-link"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_inline_svg, {
                        src: require(`@/assets/images/icons/${sideLink.icon}.svg`)
                      }, null, 8, ["src"]),
                      _createElementVNode("span", _hoisted_7, _toDisplayString(sideLink.title), 1),
                      (sideLink.notifications)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["to", "onClick"])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ])
    ], 2)
  ]))
}